const Procurement = {
    searchProducts: () =>'admin/procurement/products-list',
    viewApi:()=>'store/purchase-cart/view',
    addProductApi:()=>'store/purchase-cart/add',
    removeProductApi:(id:string)=>`store/purchase-cart/remove-item/${id}`,
    checkoutApi:()=>'admin/procurement',
    storeAccountDetail:(id:string)=>`admin/procurement/store/${id}/account-details`
  }
  export default Procurement